export default "__VITE_ASSET__DBJYnsk___"